// .directive('hpDynamicTextButton',

export default function () {
    return {
        restrict: 'A',
        scope: {
            hpSpinnerButtonStatus: '=',
            hpSpinnerButtonTexts: '=',
            hpSpinnerButtonStyles: '=',
        },
        link(scope, element, attr) {
            element.html(attr.hpSpinnerButton);
            scope.$watch('hpSpinnerButtonStatus', () => {
                element.html(scope.hpSpinnerButtonTexts[scope.hpSpinnerButtonStatus]);
                if (scope.hpSpinnerButtonStatus === 2 && scope.hpSpinnerButtonStyles === true) {
                    element.addClass('btn-success');
                    element[0].blur();
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpDynamicTextButton.directive.js